@if(externalRequest.file) {
  <div class="open-certificate-container">
    <dx-button
      type="default"
      stylingMode="contained"
      [icon]="'https://img.icons8.com/?size=100&id=11169&format=png&color=000000'"
      [text]="'APPROVAL-REQUEST.OPEN-CERTIFICATE-FILE' | translate"
      (onClick)="openCertificateFilePopup()"
      class="certificate-button"
    >
    </dx-button>
  </div>
}

<dx-form
  #updateRequestForm
  [formData]="reviewForm"
  [showColonAfterLabel]="false"
  labelMode="floating"
>
  <dxi-item itemType="group">
    <dxo-col-count-by-screen
      [xs]="1"
      [sm]="1"
      [md]="1"
      [lg]="4"
    ></dxo-col-count-by-screen>
  </dxi-item>
  <dxi-item dataField="name">
    <dxo-label [text]="'COMMON.FIELDS.TITLE' | translate"></dxo-label>
    <dxi-validation-rule
      type="required"
      [message]="'VALIDATIONS.TITLE-REQUIRED' | translate"
    ></dxi-validation-rule>
  </dxi-item>
  <dxi-item
    dataField="description"
    editorType="dxTextArea"
    cssClass="certificate-description"
  >
    <dxo-label
      [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
    ></dxo-label>
    <dxi-validation-rule
      type="required"
      [message]="'VALIDATIONS.DESCRIPTION-REQUIRED' | translate"
    ></dxi-validation-rule>
  </dxi-item>
  <dxi-item itemType="group">
    <dxo-col-count-by-screen
      [xs]="1"
      [sm]="1"
      [md]="1"
      [lg]="2"
    ></dxo-col-count-by-screen>
    <dxi-item
      [editorOptions]="trainingTypeOptions"
      dataField="trainingType"
      editorType="dxSelectBox"
    >
      <dxo-label [text]="'COMMON.FIELDS.TRAINING-TYPE' | translate"></dxo-label>
      <dxi-validation-rule
        type="required"
        [message]="'VALIDATIONS.TRAINING-TYPE-REQUIRED' | translate"
      ></dxi-validation-rule>
    </dxi-item>
    <dxi-item dataField="date" editorType="dxDateBox">
      <dxo-label [text]="'COMMON.FIELDS.DATE' | translate"></dxo-label>
      <dxi-validation-rule
        type="required"
        [message]="'VALIDATIONS.DATE-REQUIRED' | translate"
      ></dxi-validation-rule>
    </dxi-item>
    @if(reviewForm.trainingType === 0) {
      <dxi-item>
        <app-time-picker
          [isInvalid]="!isTimeValid()"
          [disabled]="false"
          (timeChanged)="handleTimePicker($event)"
          [defaultValue]="{
            hours: reviewForm.iddHours!,
            minutes: reviewForm.iddMinutes!
          }"
          [validationMessage]="'VALIDATIONS.TRAINING-TIME-MINUTE' | translate"
        ></app-time-picker>
      </dxi-item>
    }
    <dxi-item dataField="location">
      <div *dxTemplate>
        <dx-autocomplete
          [(value)]="googleSearchText"
          [searchExpr]="autocompleteSearchFilter"
          [label]="'COMMON.FIELDS.TRAINING-LOCATION' | translate"
          [label]="'TRAINING.FORM.SEARCH-TRAINING-LOCATION' | translate"
          [dataSource]="googlePlaces"
          valueExpr="description"
          (onValueChanged)="getGooglePlaces($event)"
          (onItemClick)="setLocationPlace($event)"
          [readOnly]="false"
          labelMode="floating"
          stylingMode="outlined"
        >
        </dx-autocomplete>
      </div>
    </dxi-item>
    <dxi-item dataField="trainingCategoryId">
      <div *dxTemplate>
        <dx-drop-down-box
          #trainingCategoryDropDown
          [(value)]="reviewForm.trainingCategoryId"
          [inputAttr]="{ 'aria-label': 'Owner' }"
          valueExpr="id"
          displayExpr="name"
          [label]="('COMMON.FIELDS.TRAINING-CATEGORY' | translate)"
          [dataSource]="trainingCategories"
          labelMode="floating"
          stylingMode="outlined"
          (onValueChanged)="trainingCategoryDropDown.instance.close()"
        >
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              [searchEnabled]="true"
              [dataSource]="trainingCategories"
              keyExpr="id"
              [selectNodesRecursive]="false"
              displayExpr="name"
              (onItemClick)="onTrainingCategorySelected($event)"
            >
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      </div>
    </dxi-item>
  </dxi-item>
</dx-form>
<div class="cta-button">
  <dx-button
    [text]="'COMMON.DECLINE' | translate"
    type="danger"
    (click)="openDeclineRequestPopup()"
  ></dx-button>
  <dx-button
    [text]="'COMMON.APPROVE' | translate"
    type="normal"
    (click)="onFormSubmit()"
  ></dx-button>
</div>

@if(showCertificateFilePopup && externalRequest.file) {
  <app-file-viewer-modal
    [(showModal)]="showCertificateFilePopup"
    [file]="externalRequest.file"
  />
}

<app-decline-approval-request-modal
  [(showModal)]="showDeclineRequestPopup"
  [approvalRequestId]="externalRequest.approvalRequestId"
  (onSend)="onSubmitDeclineRequestPopup()"
/>